import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PowerbiService {
  autocheckData: any;

  constructor(private http: HttpClient) { }

  getEmbedToken({reportId, groupId}: {reportId: string, groupId: string}) {
    return forkJoin([
        this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/getembedtoken", {reportId, groupId})
    ])
  }

  
  getspToken() {
    return this.http.get<{ accessToken: string }>(`${window.location.protocol}//${window.location.hostname}${window.location.port !== '' ? ':8080' : ''}/data/getsptoken`)
  }

  getAutocheckData() {
    return this.autocheckData;
  }

  setAutocheckData(data: any) {
    this.autocheckData = data;
  }


}